
import { Component, Vue } from "vue-property-decorator";
import Axios from 'axios';

declare type LoginForm = {
  id: string;
  password: string;
}

@Component
export default class LinkSns extends Vue {
  loginForm = {} as LoginForm;
  idValidated = false;

  validateMemId(): void {
    if(!this.loginForm.id) {
      this.$toast(this.$t('login.a0006')); // 아이디를 입력해 주세요.
      return;
    } 

    Axios.get(`/join/validation/${this.loginForm.id}`)
    .then(r=>{
      if(r.data) {
        this.idValidated = true;
      } else {
        alert(this.$t('join.a0010')); // 연동할 수 없는 아이디 입니다.
      }
    });
  }

  // 연동하기
  linkSns(): void {
    if(!this.loginForm.id || !this.loginForm.password) {
      alert(this.$t('login.a0005')); // 아이디 또는 비밀번호를 확인해 주세요
    }
    Axios.post('/join/link-sns', this.loginForm)
    .then(()=>{
      alert(this.$t('join.a0020')); // 입력하신 아이디와 계정 연동이 완료 되었습니다.
      this.$router.push({name: 'Main'});
    });
  }

  // 신규가입 바로 가기
  signUp(): void {
    this.$router.push({name: 'SignUp1'});
  }
}
